// Fire-and-forget capture for Clinity Clinics / Premium waitlist taps.
// Uses fetch keepalive so the POST survives the imminent navigation to wa.me.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Log a one-tap waitlist interest.
 * @param {Object} payload
 * @param {string} payload.source - e.g. 'clinics_hero' | 'result_premium' | 'experts_premium'
 * @param {string} [payload.assessment_id]
 * @param {string} [payload.name]
 * @param {string} [payload.city]
 * @param {string} [payload.whatsapp]
 * @param {string} [payload.email]
 * @param {string} [payload.language]
 */
export function joinWaitlist(payload) {
  try {
    const body = {
      ...payload,
      referrer: typeof document !== 'undefined' ? document.referrer : undefined,
    };
    fetch(`${API}/clinics/waitlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => { /* swallow — non-critical */ });
  } catch (_) { /* noop */ }
}
